import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

// When bulk uploading profiles, the fetchCategory option is used to only fetch the category when adding the last batch of entries
const addEntriesBulk = async (
  module,
  { entries, categoryID, opts = { fetchCategory: true } }
) => {
  const api = useApiStore();
  const { dispatch } = module;
  const config = Object.assign(getDefaultOpts(), opts);
  const res = await dispatch("httpRequest", {
    func: api.addEntriesBulk(categoryID, entries),
    config,
  });
  if (opts.fetchCategory) {
    await dispatch("fetchCategory", { id: categoryID, opts });
  }
  return res;
};

export { addEntriesBulk };
